import { useComputed } from '@preact/signals';
import { getCurrentEpisode } from '../global-state/audio-signals';
import { useUserDataStore } from '../global-state/user-data';
import { Episode } from '../models/podcasts';

export function checkIfPlayed(episode: Episode, progress?: [number, number]) {
  progress =
    progress ||
    useUserDataStore.getState().episodesProgress[
      `${episode.podcastId}|${episode.guidHash}`
    ];
  if (!progress) return false;

  const [, secondsLeft] = progress;

  // If an episode is currently playing, only mark it played when it's complete
  if (secondsLeft >= 1) {
    const currentEpisode = getCurrentEpisode();
    if (areEpisodesTheSame(episode, currentEpisode)) {
      return false;
    }
  }

  // Mark played if less than a minute left
  if (secondsLeft < 60) return true;

  // Mark played if less than 5% of the podcast left (up to 3 minutes)
  // 5% of a half-hour podcast is 1.5 minutes
  if (episode.duration) {
    return secondsLeft < Math.min(3 * 60, episode.duration * 0.05);
  }

  return false;
}

export function useIsPlayed(episode: Episode) {
  // Update when these dependencies change

  // 1. Episode progress changes
  useUserDataStore(
    (s) => s.episodesProgress[`${episode.podcastId}|${episode.guidHash}`]
  );

  // 2. Episode is currently playing
  useComputed(() => areEpisodesTheSame(episode, getCurrentEpisode()));

  // Return current value
  return checkIfPlayed(episode);
}

function areEpisodesTheSame(a: Episode, b?: Episode) {
  return a === b || (b && a.podcastId === b.podcastId && a.guidHash === b.guidHash);
}
